import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        charge: {},
        charges: {data: [], current_page: 1, total: 0, per_page: 10},
        payments: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {
                    charge_type_id: [],
                    amount: [],
                    effective_date: [],
                    project_id: []
                }
            }
        },
        has_errors: false,
        loading: false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        charges: state => state.charges,
        charge: state => state.charge,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
        loading: state => state.loading,
        payments: state => state.payments
    },
    mutations: {
        setLoading(state, status) {
            state.loading = status
        },
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setCharges(state, data) {
            state.charges = data;
        },
        setCharge(state, data) {
            state.charge = data;
        },
        setChargePayments(state, data) {
            state.payments = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {
                            charge_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },

        async createCharge({commit}, data) {
            const {silent, ...payload} = data;
            try {
                commit('hasErrors', false)
                const response = await api.createCharge(payload);
                if (!silent) {
                    ElMessage.success('Charge created successfully!');
                }
                return response?.data;
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                if (!silent) {
                    ElMessage.error(e.response.data.message);
                }
                throw e;
            }
        },

        async getCharges({commit}, filters) {
            try {
                commit('setLoading', true)
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getCharges(filters);
                commit('setCharges', response);
                commit('setLoading', false)
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },
        async getCharge({commit}, filters) {
            try {
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getCharge(filters);
                commit('setCharge', response?.data);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getChargesForTenancy({commit}, filters) {
            try {
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getChargesForTenancy(filters);
                commit('setCharges', response);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getChargePayments({commit}, filters) {
            try {
                commit('setChargePayments', {data: [], current_page: 1, total: 0, per_page: 10})
                commit('activateLoading', 'user/list', {root: true});
                const response = await api.getChargePayments(filters);
                commit('setChargePayments', response);
                commit('deactivateLoading', 'county/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getChargesWithPayments({commit}, filters) {
            try {
                commit('activateLoading', 'charge_type/list', {root: true});
                const response = await api.getChargesWithPayments(filters);
                commit('setCharges', response);
                commit('deactivateLoading', 'charge_type/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async createCharges({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.createCharge(data);
                dispatch('getCharges', {
                    paginate: true
                })
                ElMessage.success('Charge created successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('hasErrors', true)
                commit('setErrors', e.response.status === 422 ? e.response : {
                    data: {
                        errors: {
                            charge_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                })
                ElMessage.error(e.response.data.message);
            }
        },
        async editCharge({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                commit('hasErrors', false)
                await api.editCharge(data);
                dispatch('getCharges', {
                    paginate: true
                });
                ElMessage.success('Charge updated successfully!');
                commit('setLoading', false)
                commit('setDialogVisible', false)
            } catch (e) {
                commit('setLoading', false)
                commit('setErrors', e.response.status === 422 ? e.response : {
                    data: {
                        errors: {
                            charge_type_id: [],
                            amount: [],
                            effective_date: [],
                            project_id: []
                        }
                    }
                })
                commit('hasErrors', true)
                ElMessage.error(e.response.data.message);
            }
        },

        async deleteCharge({dispatch, commit}, data) {
            try {
                commit('setLoading', true)
                await api.deleteCharge(data);
                dispatch('getCharges', {
                    paginate: true
                });
                ElMessage.success('Charge removed successfully!');
            } catch (e) {
                commit('setLoading', false)
                ElMessage.error(e.response.data.message);
            }
        },

        async exportChargesReport({commit}, {filters, format}) {
            try {
                commit('setLoading', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportChargesReport({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Charges_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setLoading', false);
            } catch (e) {
                commit('setLoading', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },


    }
}
